import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const mappingUrl = `${environment.apiUrl}/mappingfiles`;
const osmToNwbMappingUrl = `${mappingUrl}/osmToNwb`;
const nwbToOsmMappingUrl = `${mappingUrl}/nwbToOsm`;

@Injectable()
export class MappingTablesService {
  constructor(private readonly httpService: HttpService) {}

  getOsmToNwbMappingTables(): Observable<string[]> {
    return this.httpService.get(osmToNwbMappingUrl);
  }

  getNwbToOsmbMappingTables(): Observable<string[]> {
    return this.httpService.get(nwbToOsmMappingUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/mapping-tables.service.ts